import MultipleClientReportFilters from "./components/MultipleClientReportFilters";
import MultipleClientReportTable from "./components/MultipleClientReportTable";
import PageWrapper from "../../../components/Page/PageWrapper";
import PageTitle from "../../../components/Page/PageTitle";
import { useTranslation } from "react-i18next";

function MultipleReport() {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.multipleReports")} />
      <MultipleClientReportFilters />
      <MultipleClientReportTable />
    </PageWrapper>
  );
}

export default MultipleReport;
